import { Outlet } from 'react-router-dom'
import { TopBar } from '../components/TopBar.jsx'
import { BottomNav } from '../components/BottomNav.jsx'
import { EvenProvider } from '../hooks/useEven.jsx'

export function Dashboard() {
  return (
    <EvenProvider>
      <div className="app-shell">
        <TopBar />
        <div className="app-content">
          <Outlet />
        </div>
        <BottomNav />
      </div>
    </EvenProvider>
  )
}
